import React from "react";
import { BarChart3, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";

// EngagementWidget — Honest-only.
// Phase 1 analytics has not shipped yet. This card intentionally renders a
// clear "Coming Soon" state so users know cross-platform engagement metrics
// (Facebook, Instagram, X, LinkedIn) are on the roadmap. No fake, sample,
// estimated, or placeholder numbers are ever displayed. The /stats/engagement
// endpoint remains dormant for future use.
//
// The `data` prop is accepted for backward compatibility with Dashboard.js
// but intentionally not rendered as numbers.
export default function EngagementWidget(_props) {
  return (
    <div
      className="rounded-md border border-dashed border-[color:var(--border-subtle)] bg-[color:var(--surface-2)] p-5"
      data-testid="engagement-coming-soon"
    >
      <div className="flex items-start gap-3">
        <div
          className="h-10 w-10 rounded-md bg-[color:var(--surface-3)] border border-[color:var(--border-subtle)] flex items-center justify-center text-[color:var(--text-2)] shrink-0"
          aria-hidden="true"
        >
          <BarChart3 className="h-5 w-5" />
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="font-display text-sm font-semibold text-[color:var(--text-1)]">
              Post Performance
            </div>
            <Badge
              variant="secondary"
              className="text-[10px] uppercase tracking-wider inline-flex items-center gap-1"
              data-testid="engagement-coming-soon-badge"
            >
              <Clock className="h-3 w-3" aria-hidden="true" />
              Coming Soon
            </Badge>
          </div>

          <p
            className="text-[12px] text-[color:var(--text-2)] mt-2 leading-relaxed"
            data-testid="engagement-coming-soon-body"
          >
            Real engagement analytics for Facebook, Instagram, X, and LinkedIn
            are coming soon. You&rsquo;ll be able to track impressions, reach,
            likes, comments, shares, and other available platform metrics
            directly in Postmoro.
          </p>

          <p
            className="text-[11px] text-[color:var(--text-3)] mt-2 leading-relaxed"
            data-testid="engagement-coming-soon-note"
          >
            Availability will vary by platform and connected-account permissions.
          </p>
        </div>
      </div>
    </div>
  );
}
